exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-facebook-login[data-v-7e5cd0bc]{cursor:pointer}.v-facebook-login .login-slot[data-v-7e5cd0bc]{padding-left:.5rem}", ""]);

// exports
